import React, { useCallback, useEffect } from 'react';
import L from 'leaflet';
import { Marker, Popup, Tooltip, useMap } from 'react-leaflet';
import MarkerClusterGroup from '@changey/react-leaflet-markercluster';
import '../../icons/node-icons.css';
import useMapData from '../../Context/MapDataContext';
import { Link } from 'react-router-dom';
import './GISMap.css';
import { alarmsSeverity } from '../../constants';
import { useGlobalFilterData } from '../../hooks/useGlobalFilterData';
import { renderToString } from 'react-dom/server';
import { Icon } from '@cv/eds-react';
import useCustomerData from '../../Context/CustomerDataContext';
import {
  fetchCircleData,
  fetchCityData,
  fetchSiteData,
  setSelectedRegionData,
  setSelectedCircleData,
  setSelectedCityData,
  setSelectedSitesData,
  resetFilters
} from '../../components/GlobalContext/GlobalfiltersData';

const ShowSites = ({ data, handleNodeClick }) => {
   const { regionData, dispatch } = useGlobalFilterData();
    const { customer } = useCustomerData();
  const map = useMap();
  const { setZoom, setMapCenter, zoom, mapCenter } = useMapData();
  const { selectedSites } = useGlobalFilterData();

  const fetchIcon = (id, alarms) => {
    const getAlarmNumber = (a) => {
      for (let i = a.length - 1; i >= 0; i--) {
        if (a[i]) {
          return i;
        }
      }
      return 0;
    };

    const commonIconProperties = {
      iconSize: zoom > 7 ? [30, 30] : [20, 20],
      className: selectedSites?.find((site) => site.nodeId === id)
        ? `map_icon map_icon${getAlarmNumber(alarms)} map_icon_selected`
        : `map_icon map_icon${getAlarmNumber(alarms)}`
      // className: `map_icon map_icon${getAlarmNumber(alarms)}`
    };
    return new L.divIcon({
      html: '<i class="icon-site"/>',
      ...commonIconProperties
    });
  };

  useEffect(() => {
    map.on('click', () => {
      let selectedClusterElement = document.getElementsByClassName('selectedCluster')
      if (selectedClusterElement?.length > 0) {
        selectedClusterElement[0]?.classList?.remove('selectedCluster');
      }
    })
  }, [map]);

  // const updateMapData = () => {
  //   setZoom(map.getZoom());
  //   setMapCenter([map.getCenter()?.lat, map.getCenter()?.lng]);
  // };

  // const onMove = useCallback(() => {
  //   updateMapData();
  // }, [map]);

  // useEffect(() => {
  //   updateMapData();
  // }, [map]);

  // useEffect(() => {
  //   map.on('move', onMove);

  //   return () => {
  //     map.off('move', onMove);
  //   };
  // }, [map, onMove]);

  // useEffect(() => {
  //   map.setView(mapCenter, zoom);
  // }, [zoom, mapCenter]);

   const handleRedirect = async (npaNxx, circle, city, site ) => {
    if (!npaNxx) {
      return;
    }
   // Set Region
    const selectedRegion = regionData?.find((r) => r.name === npaNxx);
    if (selectedRegion) {
      await dispatch(setSelectedRegionData([selectedRegion]));
    } else {
      await dispatch(setSelectedRegionData([]));
    }

  
   if (selectedRegion) {
    // Set Circles
    let circleData = [];
    const request= {
      region: [selectedRegion?.name]
     }
      circleData = await dispatch(fetchCircleData(customer, request));
      const selectedCircle = circleData?.find((s) => s.name === circle);
      if (selectedCircle) {
        await dispatch(setSelectedCircleData([selectedCircle]));
      } else {
        await dispatch(setSelectedCircleData([]));
      }
    //Set Cities
    let cityData = [];
     const cityrequest= {
      region: [selectedRegion?.name],
      circle: [selectedCircle?.name]
     }
    cityData = await dispatch(fetchCityData(customer, cityrequest));
    const selectedCity = cityData?.find((s) => s.name === city);
    if (selectedCity) {
      await dispatch(setSelectedCityData([selectedCity]));
    } else {
      await dispatch(setSelectedCityData([]));
    }
 
    // Set Sites
    let siteData = [];
    const siterequest= {
      region: [selectedRegion?.name],
      circle: [selectedCircle?.name],
      city: [selectedCity?.name]
     }
    siteData = await dispatch(fetchSiteData(customer, siterequest));
    const selectedSites = siteData.find((s) => s.name === site);
    if (selectedSites) {
      await dispatch(setSelectedSitesData([selectedSites]));
    } else {
      await dispatch(setSelectedSitesData([]));
    }
  }
    
  };

  const createClusterCustomIcon = function (cluster) {
    cluster.on('click', () => {
      let flatClassNames = Object.entries(cluster?._icon?.classList)?.flat()
      if (flatClassNames.includes('selectedCluster')) {
        cluster._icon.classList.remove("selectedCluster");
      } else {
        let selectedClusterElement = document.getElementsByClassName('selectedCluster')        
        if (selectedClusterElement?.length > 0) {
          selectedClusterElement[0]?.classList?.remove('selectedCluster');
        }
        setTimeout(() => {
          cluster._icon.classList.add("selectedCluster");
        }, 300);
      }
    })

    const markers = cluster.getAllChildMarkers();
    const getAlarmNumber = () => {
      for (let i = 0; i < markers.length; i++) {
        for (let j = markers[i].options.alarms.length - 1; j >= 0; j--) {
          if (markers[i].options.alarms[j]) {
            return j;
          }
        }
      }
      return 0;
    };
    return L.divIcon({
      html: renderToString(
        <Icon type="globe" title={`${cluster.getChildCount()} sites`} />
      ),
      className: `map_icon map_icon${getAlarmNumber()}`,
      iconSize: L.point(20, 20, true)
    });
  };

  return (
    <MarkerClusterGroup
      iconCreateFunction={createClusterCustomIcon}
      maxClusterRadius="40"
      disableClusteringAtZoom="13"
    >
      {data?.map((node) => {
       // console.log("nodedetails",node)
        if (node.latitude && node.longitude) {
          return (
            <Marker
              key={node.nodeId}
              position={[node.latitude, node.longitude]}
              // eventHandlers={{
              //   click: () => handleNodeClick(node)
              // }}
              icon={fetchIcon(node.nodeId, node.alarms)}
              alarms={node.alarms}
            >
              <Popup>
                <Link
                   to={`/monitoring?region=${node?.npaNxx}&stateProv=${node?.stateProv}&city=${node?.city}&site=${node.label}`}
                   onClick={() => handleRedirect(node?.npaNxx, node?.stateProv, node?.city, node?.label)}
                >
                  {`Monitoring: ${node?.region} ${node.label}`}
                </Link>
                <br></br>
                <Link
                   to={`/inventory?region=${node?.npaNxx}&stateProv=${node?.stateProv}&city=${node?.city}&site=${node.label}`}
                   onClick={() => handleRedirect(node?.npaNxx, node?.stateProv, node?.city, node?.label)}
                >
                  {`Inventory: ${node?.region} ${node.label}`}
                </Link>
                <br></br>
                <Link
                   to={`/view/infra-topology`}
                   onClick={() => handleRedirect(node?.npaNxx, node?.stateProv, node?.city, node?.label)}
                >
                  {`Topology: ${node?.region} ${node.label}`}
                </Link>
              </Popup>
              <Tooltip>
                <table>
                  <thead></thead>
                  <tbody>
                    {node.alarms.map((alarm, i) => (
                      i >= 0 &&
                      <tr key={i}>
                        <td>{alarmsSeverity[i]}&nbsp;</td>
                        <td align="right">{alarm}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Tooltip>
            </Marker>
          );
        }
      })}
    </MarkerClusterGroup>
  );
};

export default ShowSites;
